// extracted by mini-css-extract-plugin
module.exports =  {"tag":"du2r8JSyqN5AGJJGcdeC"};